export class CommitterCompactionStrategyStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tasks",
            "baseName": "tasks",
            "type": "number",
            "format": ""
        },
        {
            "name": "inputFiles",
            "baseName": "inputFiles",
            "type": "number",
            "format": ""
        },
        {
            "name": "inputBytes",
            "baseName": "inputBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "partitions",
            "baseName": "partitions",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CommitterCompactionStrategyStats.attributeTypeMap;
    }
    constructor() {
    }
}
